import { render, staticRenderFns } from "./Blog.vue?vue&type=template&id=6181e352&scoped=true&"
var script = {}
import style0 from "./Blog.vue?vue&type=style&index=0&id=6181e352&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6181e352",
  null
  
)

export default component.exports